var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"rgb(240, 235, 248)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }